import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Game from './pages/Game'
import Play from './pages/Play'
import Curate from './pages/Curate'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Game />} />
        <Route path="/play" element={<Play />} />
        <Route path="/curate" element={<Curate />} />
      </Routes>
    </BrowserRouter>
  )
}
